import logging from './logging';

/**
 * @param {string} event
 * @param {Record<string,*>|undefined} data
 *
 * @returns {void}
 */
export default function gtmDataLayerPush(event, data = {}) {
	if (!event) {
		throw new Error('Event is required');
	}

	if (typeof event !== 'string') {
		throw new Error('Event must be a string');
	}

	if (data) {
		try {
			let d = JSON.stringify(data);

			data = JSON.parse(d);
		} catch (e) {
			throw e;
		}
	}

	logging('GTM DataLayer Push', () => {
		console.log('Event:', event);
		console.log('Data:', data);
	});

	window.dataLayer?.push({
		event,
		...data,
	});
}
